module.exports = __webpack_public_path__ + "img/chat.bc7e7129.svg";